<template lang="">
  <div>
    <section id="subVisual" class="subVis2">
      <div>
        <h4>QUEST</h4>
        <p>
          축적된 노하우와 기술력으로 최적의 솔루션과 서비스를 제공하겠습니다.
        </p>
      </div>
    </section>
    <main id="cont">
      <div id="overview" class="subCon">
        <section class="platform1">
          <h3 class="con_tit" id="about">About LiveReorg</h3>

          <div class="img">
            <v-img
              src="@/assets/img/quest/livereorg/about.png"
              alt=""
              style="
                width: 60%;
                height: 60%;
                border-radius: 8px;
                box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
                  0 6px 20px 0 rgba(0, 0, 0, 0.19);
              "
            />
          </div>

          <div class="con">
            <p style="font-size: 20px">
              # Reorg 작업은 저장 장치의 효율적인 사용과 시스템의 성능 향상 및
              디스크 공간 활용을 위해 Data를 Block에 재배치 혹은 재편성(재구성)
              하는 작업
              <br /># Reorg 작업을 통해 공간 단편화 문제, HWM(High Water Mark)
              상승 문제, Chained Rows로 인한 I/O 성능 저하 문제, <br />테이블 및
              인덱스의 I/O 경합 문제, 인덱스 검색 성능 저하 문제를 해결하여
              시스템의 성능 향상
            </p>
          </div>
        </section>

        <div class="H60"></div>

        <h3 class="con_tit" id="why">Why You Need LiveReorg</h3>

        <div class="img">
          <h4>#1 Data Block 조각모음</h4>
          <v-img
            src="@/assets/img/quest/livereorg/need1.png"
            alt=""
            style="
              width: 60%;
              height: 60%;
              border-radius: 8px;
              box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
                0 6px 20px 0 rgba(0, 0, 0, 0.19);
              margin: 0 auto;
              align-items: center;
            "
          />
          <div class="H60"></div>
          <h4>#2 HWM 축소로 데이터 Scan 범위 축소</h4>
          <v-img
            src="@/assets/img/quest/livereorg/need2.png"
            alt=""
            style="
              width: 60%;
              height: 60%;
              border-radius: 8px;
              box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
                0 6px 20px 0 rgba(0, 0, 0, 0.19);
              margin: 0 auto;
              align-items: center;
            "
          />
          <div class="H60"></div>
          <h4>#3 Row Changing & Migration</h4>
          <v-img
            src="@/assets/img/quest/livereorg/need3.png"
            alt=""
            style="
              width: 60%;
              height: 60%;
              border-radius: 8px;
              box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
                0 6px 20px 0 rgba(0, 0, 0, 0.19);
              margin: 0 auto;
              align-items: center;
            "
          />
          <div class="H60"></div>
          <h4>#4 Online ReOrg</h4>
          <v-img
            src="@/assets/img/quest/livereorg/need4.png"
            alt=""
            style="
              width: 60%;
              height: 60%;
              border-radius: 8px;
              box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
                0 6px 20px 0 rgba(0, 0, 0, 0.19);
              margin: 0 auto;
              align-items: center;
            "
          />
        </div>

        <div class="H60"></div>

        <h3 class="con_tit" id="feature">LiveReorg Feature</h3>

        <div class="img">
          <h4>#1 LiveReorg Manager</h4>
          <v-img
            src="@/assets/img/quest/livereorg/feature1.png"
            alt=""
            style="
              width: 60%;
              height: 60%;
              border-radius: 8px;
              box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
                0 6px 20px 0 rgba(0, 0, 0, 0.19);
              margin: 0 auto;
              align-items: center;
            "
          />
          <div class="H60"></div>
          <h4>#2 다양한 보고서</h4>
          <v-img
            src="@/assets/img/quest/livereorg/feature2.png"
            alt=""
            style="
              width: 60%;
              height: 60%;
              border-radius: 8px;
              box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
                0 6px 20px 0 rgba(0, 0, 0, 0.19);
              margin: 0 auto;
              align-items: center;
            "
          />
          <div class="H60"></div>
          <h4>#3 재구성 작업의 연속성 보장</h4>
          <v-img
            src="@/assets/img/quest/livereorg/feature3.png"
            alt=""
            style="
              width: 60%;
              height: 60%;
              border-radius: 8px;
              box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
                0 6px 20px 0 rgba(0, 0, 0, 0.19);
              margin: 0 auto;
              align-items: center;
            "
          />
        </div>
      </div>
    </main>
  </div>
</template>
<script>
export default {};
</script>
<style lang=""></style>
